import { TabPanel } from '@mui/lab';
import { Box } from '@mui/material';
import { Input } from '../../../../../shared/components/Input';
import { InputSelect } from '../../../../../shared/components/InputSelect';
import { OPTIONS_TRANSPORT } from '../../../../../shared/utils/const/TransportsOptions';
import {
  formatCurrency,
  formatDate,
} from '../../../../../shared/utils/helpers/numbers';
import { Column } from '../../../../Components/Table/Types';
import ComponentTable from '../../../../Components/Table/Index';
import Divider from '@mui/material/Divider';

interface TabTransporteParcelasProps {
  nfPreView: any;
}

export const TabTransporteParcelas = ({ nfPreView }: TabTransporteParcelasProps) => {

  const columns: Column[] = [
    { id: 'num_parcela', label: 'Nº Parcela', align: 'center', width: 200 },
    {
      id: 'nfeParc_vencimento',
      label: 'Vencimento',
      align: 'center',
    },
    { id: 'nfeParc_valor', label: 'Valor' },
  ];

  const rows = nfPreView?.parcelas ? nfPreView.parcelas.map((item: any) => {
    return {
      num_parcela: item.num_parcela,
      nfeParc_valor: formatCurrency(item?.nfeParc_valor ?? 0, 2, 2),
      nfeParc_vencimento: formatDate(item?.nfeParc_vencimento ?? ''),
    };
  }) : [];

  return (
    <TabPanel value='2'>
      <Box className='grid grid-cols-8 gap-3 h-full'>
        <Input
          disabled={true}
          label='Transportadora'
          className='col-span-3'
          name='ID'
          value={nfPreView.transp_nome}
        />
        <Input
          disabled={true}
          label='UF'
          className='col-span-1'
          name='ID'
          value={nfPreView.transp_uf}
        />
        <Input
          disabled={true}
          label='Valor Frete'
          className='col-span-2'
          name='ID'
          value={formatCurrency(nfPreView?.nfe_valorFrete ?? 0, 2, 2)}
        />
        <InputSelect
          label='Tipo Frete'
          name='transporte.mod_frete'
          size='small'
          items={OPTIONS_TRANSPORT}
          className={'col-span-3'}
          value={nfPreView?.nfe_fretipo}
          disabled={true}
          error={undefined}
          helperText={undefined}
        />
        <Divider className={'col-span-8 py-4'} />
        <Box className={'col-span-8 flex flex-row justify-between'}>
          <p className={'font-bold'}>Parcelas</p>
          <Box className={'flex gap-3'}>
            <p className={'font-bold'}>Total:</p>
            <p className={'font-bold'}>
              {formatCurrency(nfPreView?.nfe_valorTotalNf ?? 0, 2, 2)}
            </p>
          </Box>
        </Box>

        <Box className={'col-span-8'}>
          <ComponentTable columns={columns} rows={rows} tableHeight={'25vh'} />
        </Box>
      </Box>
    </TabPanel>
  );
};